import React, { Fragment, ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import InstructionalText from '../../../../../components/ssap/notifications/InstructionalText';
import UniversalInput from '../../../../../lib/wrappers/UniversalInput';
import ValidationErrorMessage from '../../../notifications/ValidationErrorMessage';

// Utils

import { normalizeNameOfPerson } from '../../../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { DROPDOWN_OPTIONS } from '../../../../../constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '../../../../../constants/inputs/inputTypes';
import { VALIDATION_ERROR_MESSAGES } from '../../../../../constants/inputs/validationErrorMessages';
import { VALIDATION_TYPES } from '../../../../../constants/inputs/validationTypes';

// Types

import { SsapData } from '../../../SsapTypes';

interface IncarcerationAttestation {
    actions: {
        getTopLevelValidation: Function,
        onFieldChange_data: Function,
        onFieldChange_incarceration: Function
    },
    data: SsapData,
    formName: string,
    isFormSubmitted: boolean
}

const IncarcerationAttestation = (props: IncarcerationAttestation): ReactElement => {
    const {
        actions: {
            getTopLevelValidation,
            onFieldChange_data,
            onFieldChange_incarceration
        },
        data,
        data: {
            incarcerationAsAttestedIndicator,
            taxHousehold: {
                householdMember: householdMembers
            }
        },
        formName,
        isFormSubmitted
    } = props;

    return (
        <fieldset className = 'usa-fieldset' >
            <ValidationErrorMessage
                isVisible = { isFormSubmitted && !getTopLevelValidation() }
                messageText = { VALIDATION_ERROR_MESSAGES.ANY_VALUE }
                errorClasses = { [ 'margin-l-0' ] }
            />
            <InstructionalText
                Component={
                    <legend data-instructions = 'instructional_text.incarceration'>
                        { 'ssap.sign_and_review.are_any_applicants_incarcerated' }
                    </legend>
                }
                required
            />
            <ul className = 'usa-list usa-list--unstyled' >
                <li>
                    <UniversalInput
                        label = { {
                            text: 'ssap.input.label.nobody_is_incarcerated',
                        } }
                        inputData = { {
                            isInputRequired: false,
                            type: INPUT_TYPES.CHECKBOX,
                            classes: [ 'disp-styl' ],
                            name: 'incarcerationAsAttestedIndicator',
                            checked: incarcerationAsAttestedIndicator,
                            value: incarcerationAsAttestedIndicator,
                            currentData: data,
                            fields: [ ]
                        }}
                        inputActions = { {
                            onFieldChange: onFieldChange_data
                        } }
                        underFormControl
                        parentForm = { { name: formName } }
                    />
                </li>

                {
                    !incarcerationAsAttestedIndicator &&

                    householdMembers.map((member, i) => {
                        const {
                            name,
                            name: {
                                firstName
                            },
                            incarcerationStatus: {
                                incarcerationStatusIndicator,
                                incarcerationPendingDispositionIndicator
                            },
                            applyingForCoverageIndicator
                        } = member;

                        return (
                            <Fragment key = { `${ firstName }_${ i }` } >
                                {
                                    applyingForCoverageIndicator &&

                                        <Fragment>
                                            <li>
                                                <UniversalInput
                                                    label = { {
                                                        text: 'ssap.input.label.is_incarcerated',
                                                        labelTextReplacements: {
                                                            personName: normalizeNameOfPerson(name)
                                                        }
                                                    } }
                                                    inputData = { {
                                                        type: INPUT_TYPES.CHECKBOX,
                                                        classes: [ 'disp-styl margin-t-10' ],
                                                        name: 'incarcerationStatusIndicator',
                                                        checked: incarcerationStatusIndicator,
                                                        value: incarcerationStatusIndicator,
                                                        currentData: member,
                                                        fields: [ 'incarcerationStatus' ]
                                                    } }
                                                    inputActions = { {
                                                        onFieldChange: onFieldChange_incarceration
                                                    } }
                                                    indexInArray = { i }
                                                    underFormControl
                                                    parentForm = { { name: formName } }
                                                />
                                            </li>

                                            {
                                                incarcerationStatusIndicator &&

                                                <UniversalInput
                                                    legend = { {
                                                        legendText: 'ssap.input.legend.pending_disposition'
                                                    } }
                                                    label = { {
                                                        showRequiredIcon: true
                                                    } }
                                                    inputData = { {
                                                        isInputRequired: true,
                                                        type: INPUT_TYPES.RADIO_BUTTONS,
                                                        classes: [ 'disp-styl-none' ],
                                                        name: 'incarcerationPendingDispositionIndicator',
                                                        value: incarcerationPendingDispositionIndicator,
                                                        options: DROPDOWN_OPTIONS.YES_NO,
                                                        validationType: VALIDATION_TYPES.CHOSEN,
                                                        currentData: member,
                                                        fields: [ 'incarcerationStatus' ]
                                                    } }
                                                    inputActions = { {
                                                        onFieldChange: onFieldChange_incarceration
                                                    } }
                                                    indexInArray = { i }
                                                    underFormControl
                                                    parentForm = { { name: formName } }
                                                />
                                            }
                                        </Fragment>
                                }
                            </Fragment>
                        );
                    })
                }
            </ul>
        </fieldset>
    );
};

export default IncarcerationAttestation;